export default __webpack_public_path__ + "static/memoq-d3106e688c219e25deb2a01fbcec8dd3.svg";